const translations = {
  "requestCall.leaveContactInformation": "Leave your contact information",
  "requestCall.subTitle":
    "For more information about the product please fill in your contact details",
  "requestCall.name": "Name",
  "requestCall.phoneNumber": "Phone Number",
  "requestCall.email": "E-Mail",
  "requestCall.comment": "Leave a comment",
  "requestCall.acceptedMarketingText":
    "I consent to the processing of personal data for direct marketing purposes to the extent permitted by law and in accordance with ",
  "requestCall.acceptedMarketingLink": "applicable regulations",
  "requestCall.acceptedPersonalInformationText": "I agree to the terms of  ",
  "requestCall.acceptedPersonalInformationLink": "personal data processing",
  "requestCall.send": "Send",
  "requestCall.requiredField": "Filling in the specified field is mandatory",
  "requestCall.phoneNumberError": "Enter the correct number",
  "requestCall.emailError": "Enter the correct e-mail",
  "requestCall.pleaseAgreeDataProcessingRule":
    "Please agree to the data processing rules",
  "requestCall.successMessage":
    "Your message has been received! A representative from Imedi L will contact you.",
  "requestCall.onPhoneNumber": "On the phone number",
  "requestCall.onEmail": "On the email",
  "requestCall.preferContactText": "Where do you prefer to be contacted?",
};

export default translations;
